import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    lng: localStorage.getItem('i18nextLng') || 'cn', // Use stored language or default
    backend: {
      loadPath: `/retreat-my/locales/{{lng}}/{{ns}}.json?_=${Date.now()}`,
    },
    ns: ['translation'], // Default namespace
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;